// User-activity signals that reset idle timers and can trigger keepalive.
const eventTypes = [
  'keypress',
  // Explicit click/pointerdown coverage ensures normal mouse click activity always resets timers.
  'click',
  'mousemove',
  'mousedown',
  'pointerdown',
  'scroll',
  'touchmove',
  'pointermove'
]
export const addEventListeners = (listener) => {
  eventTypes.forEach((type) => {
    window.addEventListener(type, listener, false)
  })
}
export const removeEventListeners = (listener) => {
  if (listener) {
    eventTypes.forEach((type) => {
      window.removeEventListener(type, listener, false)
    })
  }
}
